import React, { useState } from 'react';
import cn from 'classnames';

import * as styles from './MobileSlider.module.scss';

export default function MobileSlider({ className, id, items, CardComponent }) {
  const [active, setActive] = useState(`${id}-0`);

  const getCardId = index => {
    return `${id}-${index}`;
  };

  return (
    <div className={className}>
      <div className={styles.scrollWrap}>
        {items.map((item, i) => {
          const cardId = getCardId(i);

          return <CardComponent key={cardId} cardId={cardId} {...item} setActive={setActive} />;
        })}
      </div>
      <div className={styles.pagination}>
        {items.map((_, i) => {
          const cardId = getCardId(i);

          return (
            <button
              key={cardId}
              className={cn(styles.paginationButton, cardId === active && styles.active)}
              onClick={() => handleClick(cardId)}
            >
              {i}
            </button>
          );
        })}
      </div>
    </div>
  );
}

function handleClick(anchor) {
  const scrollTarget = document.getElementById(anchor);
  scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
}
